export default __webpack_public_path__ + "static/media/8-Inam-Hvorfor tror du noen minoriteter blir undertrykt.2634e2f9.mp4";